import { Button } from "@/components/ui/button";
import { ArrowLeft, FileText, Users, Heart, XCircle, AlertTriangle, Camera, Shield, Scale } from "lucide-react";
import { Link } from "react-router-dom";

export default function AGB() {
  return (
    <div data-testid="agb-page" className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <Link to="/">
          <Button variant="ghost" className="mb-8 text-[#b46eb6] hover:bg-[#b46eb6]/5" data-testid="agb-back-btn">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Button>
        </Link>

        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-4" style={{ color: "#1F2937" }}>
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>
        <p className="text-lg mb-8" style={{ color: "#4B5563" }}>
          für die Teilnahme am Spendenlauf „Run for Rett"
        </p>
        <div className="section-divider mb-8" />

        {/* Event Info Box */}
        <div className="bg-gray-50 rounded-xl p-6 mb-10 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p className="text-sm font-medium" style={{ color: "#9CA3AF" }}>Veranstalter</p>
            <p className="font-semibold" style={{ color: "#1F2937" }}>Förderverein der SpVgg Willenhofen-Herrnried</p>
          </div>
          <div>
            <p className="text-sm font-medium" style={{ color: "#9CA3AF" }}>Veranstaltungstag</p>
            <p className="font-semibold" style={{ color: "#1F2937" }}>13.06.2026</p>
          </div>
          <div>
            <p className="text-sm font-medium" style={{ color: "#9CA3AF" }}>Ort</p>
            <p className="font-semibold" style={{ color: "#1F2937" }}>Herrnried</p>
          </div>
        </div>

        <div className="prose prose-lg max-w-none space-y-8" style={{ color: "#4B5563" }}>
          
          {/* 1. Veranstalter & Zweck */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <FileText className="w-6 h-6" style={{ color: "#b46eb6" }} />
              1. Veranstalter & Zweck
            </h2>
            <p>
              Der Spendenlauf „Run for Rett" wird vom <strong>Förderverein der SpVgg Willenhofen-Herrnried</strong> organisiert. 
              Ziel der Veranstaltung ist es, Spenden für wohltätige Zwecke zu sammeln – insbesondere zur 
              Unterstützung von Kindern mit Rett-Syndrom. Die Teilnahme erfolgt freiwillig und dient einem 
              gemeinnützigen Zweck.
            </p>
          </section>

          {/* 2. Anmeldung & Teilnahme */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <Users className="w-6 h-6" style={{ color: "#b46eb6" }} />
              2. Anmeldung & Teilnahme
            </h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#b46eb6" }}></span>
                <span>Die Anmeldung erfolgt online über <a href="https://www.runforrett.de" className="underline hover:no-underline" style={{ color: "#b46eb6" }}>www.runforrett.de</a>.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#b46eb6" }}></span>
                <span>Jede Anmeldung ist freiwillig und mit <strong>keiner Teilnahmegebühr</strong> verbunden.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#b46eb6" }}></span>
                <span>Die Teilnahme ist offen für <strong>alle Altersgruppen</strong>.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#b46eb6" }}></span>
                <span>Mit der Anmeldung akzeptieren Teilnehmende diese AGB.</span>
              </li>
            </ul>
          </section>

          {/* 3. Spendenoptionen */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <Heart className="w-6 h-6" style={{ color: "#b46eb6" }} />
              3. Spendenoptionen
            </h2>
            <p>Teilnehmende können auf drei Arten Spenden einbringen:</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <div className="p-4 rounded-xl" style={{ background: "rgba(180, 110, 182, 0.1)" }}>
                <p className="font-semibold" style={{ color: "#b46eb6" }}>Privatspende</p>
                <p className="text-sm mt-1">Eigene Spende pro gelaufener Runde oder Pauschale</p>
              </div>
              <div className="p-4 rounded-xl" style={{ background: "rgba(149, 225, 187, 0.15)" }}>
                <p className="font-semibold" style={{ color: "#059669" }}>Firmenspende</p>
                <p className="text-sm mt-1">Z.B. durch den Arbeitgeber</p>
              </div>
              <div className="p-4 rounded-xl" style={{ background: "rgba(180, 110, 182, 0.1)" }}>
                <p className="font-semibold" style={{ color: "#b46eb6" }}>Sponsoring</p>
                <p className="text-sm mt-1">Durch eine zugewiesene Firma</p>
              </div>
            </div>
            <p className="mt-4">
              Die Abwicklung der Spende erfolgt vor Ort in bar oder per Überweisung an den Förderverein. 
              Auf Wunsch wird eine <strong>Spendenquittung</strong> ausgestellt.
            </p>
          </section>

          {/* 4. Absage durch Teilnehmende */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <XCircle className="w-6 h-6" style={{ color: "#b46eb6" }} />
              4. Absage durch Teilnehmende
            </h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#b46eb6" }}></span>
                <span>Eine Abmeldung ist <strong>jederzeit formlos möglich</strong>, z.B. per E-Mail oder über das Kontaktformular auf der Website.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#b46eb6" }}></span>
                <span>Da keine Teilnahmegebühr erhoben wird, entstehen durch eine Absage <strong>keine Kosten</strong>.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#b46eb6" }}></span>
                <span>Nichtteilnahme am Lauf verpflichtet <strong>nicht</strong> zur Abgabe einer Spende.</span>
              </li>
            </ul>
          </section>

          {/* 5. Absage oder Änderung der Veranstaltung */}
          <section>
            <h2 className="font-heading text-2xl font-semibold mb-4" style={{ color: "#1F2937" }}>
              5. Absage oder Änderung der Veranstaltung
            </h2>
            <p>
              Sollte die Veranstaltung aus wichtigen Gründen (z.B. Unwetter) abgesagt oder verschoben werden, 
              informiert der Veranstalter rechtzeitig über die Website und Social Media.
            </p>
            <p className="mt-3">
              Einzelne Ausfälle im Organisationsteam haben keinen Einfluss auf die Durchführung, da das Event 
              durch ein engagiertes Team getragen wird.
            </p>
          </section>

          {/* 6. Haftungsausschluss */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <AlertTriangle className="w-6 h-6" style={{ color: "#b46eb6" }} />
              6. Haftungsausschluss
            </h2>
            <div className="p-4 rounded-xl mb-4" style={{ background: "rgba(239, 68, 68, 0.1)" }}>
              <p className="font-semibold" style={{ color: "#DC2626" }}>Die Teilnahme erfolgt auf eigenes Risiko.</p>
            </div>
            <p>Der Veranstalter übernimmt keine Haftung für:</p>
            <ul className="mt-3 space-y-2">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#DC2626" }}></span>
                <span>gesundheitliche Schäden</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#DC2626" }}></span>
                <span>Verletzungen</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full mt-2" style={{ background: "#DC2626" }}></span>
                <span>Diebstahl oder Sachbeschädigung</span>
              </li>
            </ul>
            <p className="mt-4">
              Teilnehmende versichern mit ihrer Anmeldung, dass sie körperlich in der Lage sind, am Lauf 
              teilzunehmen. Es wird empfohlen, bei gesundheitlichen Bedenken im Vorfeld ärztlichen Rat einzuholen.
            </p>
          </section>

          {/* 7. Foto- & Videoaufnahmen */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <Camera className="w-6 h-6" style={{ color: "#b46eb6" }} />
              7. Foto- & Videoaufnahmen
            </h2>
            <p>
              Im Rahmen der öffentlichen Veranstaltung werden Fotos und Videos durch den Veranstalter 
              sowie Pressevertreter:innen angefertigt.
            </p>
            <p className="mt-3">
              Diese können für die <strong>Öffentlichkeitsarbeit</strong> (Website, Social Media, Flyer, 
              Presseberichte etc.) verwendet werden.
            </p>
            <p className="mt-3">
              Mit der Teilnahme stimmen die Läufer:innen der möglichen Veröffentlichung zu.
            </p>
            <div className="mt-4 p-4 rounded-xl" style={{ background: "rgba(149, 225, 187, 0.15)" }}>
              <p>
                <strong>Hinweis:</strong> Sollte jemand nicht fotografiert werden wollen, bitten wir um 
                einen kurzen Hinweis vor Ort.
              </p>
            </div>
          </section>

          {/* 8. Datenschutz */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <Shield className="w-6 h-6" style={{ color: "#b46eb6" }} />
              8. Datenschutz
            </h2>
            <p>
              Personenbezogene Daten, die im Rahmen der Anmeldung erhoben werden, dienen ausschließlich 
              der Organisation des Spendenlaufs und werden <strong>nicht an Dritte weitergegeben</strong>.
            </p>
            <p className="mt-3">
              Eine ausführliche Datenschutzerklärung ist auf der Website{" "}
              <Link to="/datenschutz" className="underline hover:no-underline" style={{ color: "#b46eb6" }}>
                www.runforrett.de/datenschutz
              </Link>{" "}
              einsehbar.
            </p>
          </section>

          {/* 9. Schlussbestimmungen */}
          <section>
            <h2 className="font-heading text-2xl font-semibold flex items-center gap-2 mb-4" style={{ color: "#1F2937" }}>
              <Scale className="w-6 h-6" style={{ color: "#b46eb6" }} />
              9. Schlussbestimmungen
            </h2>
            <p>
              Sollten einzelne Regelungen dieser AGB ganz oder teilweise unwirksam sein, bleibt die 
              Gültigkeit der übrigen Bestimmungen davon unberührt.
            </p>
          </section>

        </div>

        {/* Footer Links */}
        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-wrap gap-4">
          <Link to="/impressum" className="text-sm underline hover:no-underline" style={{ color: "#b46eb6" }}>
            Impressum
          </Link>
          <Link to="/datenschutz" className="text-sm underline hover:no-underline" style={{ color: "#b46eb6" }}>
            Datenschutzerklärung
          </Link>
        </div>
      </div>
    </div>
  );
}
